import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

const Steps = () => {
  const steps = [
    {
      number: '01',
      title: 'Crie sua conta',
      items: [
        'Sem cartão de crédito para começar',
        'Suporte para médicos e veterinários',
        'Acesso imediato após o cadastro',
        'Funciona em qualquer dispositivo',
      ],
    },
    {
      number: '02',
      title: 'Configure seus dados',
      items: [
        'Adicione sua assinatura visual no PDF',
        'Configure seus locais de atendimento',
        'Crie ou importe seus templates',
      ],
    },
    {
      number: '03',
      title: 'Laudo com QR Code',
      items: [
        'Preencha em minutos com templates',
        'Gere o PDF profissional',
        'Registre o laudo com hash de integridade',
        'Compartilhe o link seguro',
      ],
    },
  ];

  return (
    <section id="como-funciona" className="bg-paper py-24 px-4 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="font-display text-[30px] font-bold text-navy">
            Do cadastro ao laudo registrado: 3 passos
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 relative">
          {steps.map((step, i) => {
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="flex flex-col items-center text-center group"
              >
                <span className="font-display text-[28px] font-bold text-navy mb-6">{step.number}</span>
                <h3 className="font-display text-xl font-bold text-ink mb-6">{step.title}</h3>
                <ul className="space-y-4 text-left w-full max-w-[240px]">
                  {step.items.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2.5">
                      <Check className="w-4 h-4 text-selo mt-0.5 shrink-0" aria-hidden="true" />
                      <span className="text-sm text-muted">{item}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Steps;
